__turbopack_context__.v({
  "container": "SmsAction-module__MTa1SW__container",
});
